import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class BunnyMapService {
  private mappings: Map<string, string> = new Map();
  private baseUrl: string = environment.videoBaseUrl;

  setMappings(mappings: Record<string, string>): void {
    this.mappings.clear();
    for (const [vimeoId, bunnyId] of Object.entries(mappings)) {
      this.mappings.set(vimeoId, bunnyId);
    }
  }

  getBunnyId(vimeoId: string): string | undefined {
    if( !this.mappings.get(String(vimeoId)) ){
      console.error("No mapping for ", vimeoId, this.mappings)
    }
    return this.mappings.get(String(vimeoId));
  }

  getPlaylistUrl(bunnyId: string | undefined): string {
    return bunnyId ? `${this.baseUrl}/${bunnyId}/playlist.m3u8` : '';
  }

  getCaptionsUrl(bunnyId: string | undefined, lang: string = 'GB'): string {
    return bunnyId ? `${this.baseUrl}/${bunnyId}/captions/${lang}.vtt?v=1` : '';
  }

  getThumbnailUrl(bunnyId: string | undefined): string {
    return bunnyId ? `${this.baseUrl}/${bunnyId}/thumbnail.jpg` : '';
  }

}
